import { render } from "./App.vue?vue&type=template&id=5102a0ec&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./scss/_global.scss?vue&type=style&index=0&lang=scss&external"
import "./App.vue?vue&type=style&index=1&id=5102a0ec&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__